module.exports = __webpack_public_path__ + "static/media/signal.0fd6f7db.svg";